import { getPlainText } from "utils/content";

export type HeaderInfo = {
    id: string;
    title: string;
    children: Array<HeaderInfo>;
};

type ParseHeadersProps = {
    jsonElement: any;
    headerLevel?: number;
    parentHeader: HeaderInfo;
};

// Receives the document tree and returns a tree of the headers, with their respective depth
// This method also adds a "headerLevel" attribute to title elements
export function parseHeaders({
    jsonElement,
    headerLevel = 1,
    parentHeader,
}: ParseHeadersProps) {
    if (!jsonElement?.elements) return;

    let siblingHeader;

    // Iterate over child elements, and everytime we find a title header
    // we set that header as the "parentHeader" for the next recursive calls
    for (const childElement of jsonElement.elements) {
        if (["figure", "informalfigure"].includes(childElement.name)) {
            // these elements contain "title" elements but they're not page
            // titles, they're specific to the figures, so no need to create
            // a header record for them
            continue;
        } else if (
            childElement.name === "title" ||
            childElement.name === "accordion-title"
        ) {
            childElement.attributes = childElement.attributes || {};
            childElement.attributes.headerLevel = headerLevel;

            const titleInfo = {
                id: childElement.attributes.id,
                title: getPlainText(childElement) || "",
                children: [],
            };

            parentHeader.children.push(titleInfo);
            siblingHeader = titleInfo;
        } else {
            const newHeaderLevel = siblingHeader
                ? headerLevel + 1
                : headerLevel;

            parseHeaders({
                jsonElement: childElement,
                headerLevel: newHeaderLevel,
                parentHeader: siblingHeader || parentHeader,
            });
        }
    }

    return parentHeader;
}
